import { render, staticRenderFns } from "./CHANGELOG.md?vue&type=template&id=15e31714"
import script from "./CHANGELOG.md?vue&type=script&lang=js"
export * from "./CHANGELOG.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports